import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
export function ProductReveal() {
  const features = ['Imágenes IA de revista', 'Contenido infinito para Instagram', 'Textos de venta que convierten', 'Anuncios que traen clientas', 'WhatsApp que cierra ventas', 'Todo en 15 minutos al día'];
  return <section className="py-8 md:py-20 px-4 max-w-5xl mx-auto text-center relative" data-id="element-333">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-64 bg-[#c9a961]/10 blur-[100px] rounded-full pointer-events-none" data-id="element-334"></div>

      <FadeIn data-id="element-335">
        <motion.div animate={{
        y: [0, -10, 0]
      }} transition={{
        duration: 4,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="inline-block mb-3 md:mb-8 relative" data-id="element-336">
          <div className="absolute inset-0 bg-[#c9a961]/20 blur-2xl rounded-full" data-id="element-337"></div>
          <span className="text-5xl md:text-8xl relative z-10 drop-shadow-[0_0_30px_rgba(201,169,97,0.5)]" data-id="element-338">
            🏆
          </span>
        </motion.div>

        <h2 className="text-3xl md:text-7xl font-black mb-3 md:mb-8 text-transparent bg-clip-text bg-gradient-to-b from-[#b8860b] via-[#c9a961] to-[#d4af37] tracking-tight drop-shadow-sm" data-id="element-339">
          MEGAPACK NEGOCIO IA LISTO™
        </h2>

        <p className="text-base md:text-4xl font-bold text-[#1a1611] mb-6 md:mb-14 max-w-3xl mx-auto leading-tight px-2" data-id="element-340">
          6 Tomos + 6 Bonos · Todo listo con IA.
        </p>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-341">
        <div className="bg-white border border-[#e8dfd0] rounded-2xl md:rounded-3xl p-5 md:p-12 max-w-3xl mx-auto text-left shadow-[0_20px_40px_rgba(201,169,97,0.1)] relative overflow-hidden" data-id="element-342">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#b8860b] via-[#c9a961] to-[#b8860b]" data-id="element-343"></div>

          <ul className="space-y-3 md:space-y-6 relative z-10" data-id="element-344">
            {features.map((feature, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: index * 0.1
          }} viewport={{
            once: true
          }} className="flex items-center gap-3 md:gap-4" data-id="element-345">
                <div className="bg-[#c9a961]/10 p-1.5 md:p-2 rounded-full border border-[#c9a961]/20 shrink-0" data-id="element-346">
                  <CheckCircle2 className="text-[#c9a961] w-5 h-5 md:w-7 md:h-7" strokeWidth={2.5} data-id="element-347" />
                </div>
                <span className="text-sm md:text-2xl text-[#1a1611] font-bold" data-id="element-348">
                  {feature}
                </span>
              </motion.li>)}
          </ul>
        </div>
      </FadeIn>
    </section>;
}